import { render } from "./homeFooter.vue?vue&type=template&id=19281339&scoped=true"
import script from "./homeFooter.vue?vue&type=script&lang=js"
export * from "./homeFooter.vue?vue&type=script&lang=js"

import "./homeFooter.vue?vue&type=style&index=0&id=19281339&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19281339"]])

export default __exports__